<script lang="ts">
	import { DropdownMenu, MenuItemList } from '@Shelly/shelly-design-system';
	import TabsActionsButton from 'src/components/TabsActionsButton.svelte';

	let showDropdown = $state(false);
</script>

<DropdownMenu bind:show={showDropdown}>
	<TabsActionsButton
		slot="trigger"
		variant="help-2"
		isActive={showDropdown}
		ariaLabel="Testing dashboard info"
		on:click={() => (showDropdown = !showDropdown)}
	/>

	<MenuItemList isGroupTitle size="m" title="Testing dashboard" />
	<MenuItemList
		isGroupItem
		size="m"
		icon="fas fa-flask"
		title="Client-only gallery of fake lights and light groups. Not persisted."
	/>
</DropdownMenu>
